import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DatePicker from "react-datepicker"
import { Modal } from 'react-bootstrap'
import Select from "react-select"

import { httpOk, GET, PUT, POST } from 'helpers/api';
import { formatDate, formatMoney, regexPhoneNumber } from 'helpers/helpers';

function Index() {
	const { t } = useTranslation()

	const hours = Array.from({ 'length': 24 }, (_, i) => i);
	const minutes = [0, 30];
	const timeList = hours.flatMap((hour) =>
		minutes.map((minute) => {
			const timeString = `${hour.toString().padStart(2, "0")}:${minute
				.toString()
				.padStart(2, "0")}`;
			return { id: timeString, name: timeString };
		})
	);

	const [data, setData] = useState([])
	const [halls, setHalls] = useState([])
	const [tables, setTables] = useState([])
	const [activeTab, setActiveTab] = useState(1)
	const [selectedItem, setSelectedItem] = useState({})
	const [modalStatus, setModalStatus] = useState(false)
	const [modalCreate, setModalCreate] = useState({ 'bool': false, 'data': {}, 'halls': [] })
	const [filter, setFilter] = useState({ 'reservation_date': new Date() })

	async function create() {
		var modalCreateCopy = { ...modalCreate };

		modalCreateCopy.data.reservation_type = 'table';
		if (!modalCreateCopy.data.reservation_date)
			modalCreateCopy.data.reservation_date = formatDate(new Date(), 'yyyy-MM-dd')
		if (modalCreateCopy.data.reservation_date)
			modalCreateCopy.data.reservation_date = formatDate(modalCreateCopy.data.reservation_date, 'yyyy-MM-dd')

		const response = await POST('/reservations', modalCreateCopy.data)
		if (httpOk(response)) {
			toggleModalCreate()
			getData()
		}
	}

	async function update() {
		const response = await PUT('/reservations', {
			'id': selectedItem.id,
			'status': 'cancelled'
		})

		if (httpOk(response)) {
			getData()
			toggleModalCancel()
		}
	}

	function selectHall(item, hallsFromServer = []) {
		var hallsCopy = []
		if (hallsFromServer.length > 0) {
			hallsCopy = hallsFromServer
		} else {
			hallsCopy = [...halls]
		}

		for (let i = 0; i < hallsCopy.length; i++) {
			if (hallsCopy[i]['id'] === item.id) {
				hallsCopy[i]['active'] = true
				setTables(hallsCopy[i]['tables'])
			} else {
				hallsCopy[i]['active'] = false
			}
		}
	}

	function selectHallModal(item) {
		var hallsCopy = [...modalCreate.halls]

		for (let i = 0; i < hallsCopy.length; i++) {
			if (hallsCopy[i]['id'] === item.id) {
				hallsCopy[i]['active'] = true
				setModalCreate({
					...modalCreate,
					'tables': JSON.parse(JSON.stringify(hallsCopy[i]['tables'])),
				})
			} else {
				hallsCopy[i]['active'] = false
			}
		}
	}

	function toggleModalCancel(bool = false, item = {}) {
		setSelectedItem(item)
		setModalStatus(bool)
	}

	function toggleModalCreate(bool = false) {
		if (bool) {
			setModalCreate({
				...modalCreate,
				'bool': bool,
				'halls': JSON.parse(JSON.stringify(halls)),
				'tables': halls.length ? JSON.parse(JSON.stringify(halls[0]['tables'])) : [],
			})
		}

		if (!bool) {
			setModalCreate({
				'bool': bool,
				'halls': [],
				'tables': [],
				'data': {},
			})
		}
	}

	function handleChange(e) {
		var modalCreateCopy = { ...modalCreate }
		modalCreateCopy.data[e.target.name] = e.target.value

		setModalCreate(modalCreateCopy)
	}

	async function searchClient() {
		var response = await GET(`/search-client/998${modalCreate.data.phone}`,
			{},
			{ loader: true, notification: false })

		if (httpOk(response)) {
			var modalCreateCopy = { ...modalCreate }

			modalCreateCopy.data.client_id = response.data.id
			modalCreateCopy.data.client_phone = response.data.phone1
			modalCreateCopy.data.client_name = response.data.first_name
			setModalCreate(modalCreateCopy)
		}
	}

	function changeDate(days) {
		var filterCopy = { ...filter }

		const newDate = new Date(filterCopy.reservation_date);
		newDate.setDate(newDate.getDate() + days);
		filterCopy.reservation_date = newDate;

		setFilter(filterCopy)
	}

	// Функция проверки, входит ли час в диапазон брони
	function isReserved(tableId, hour) {
		return data.some(reservation => {
			if (reservation.status === 'cancelled') return false;

			const startHour = parseInt(reservation.reservation_start_time.split(":")[0]); // "18:00:00" → 18
			const endHour = reservation.reservation_end_time
				? parseInt(reservation.reservation_end_time.split(":")[0]) // "19:00:00" → 19
				: null; // Если `null`, значит только startHour закрашиваем

			return reservation.table_id === tableId &&
				(hour === startHour || (endHour !== null && hour >= startHour && hour < endHour));
		});
	}

	function returnClassReservation(status) {
		if (status === 'cancelled')
			return 'bg-danger text-white'
		if (status === 'opened')
			return 'bg-primary text-white'
		if (status === 'closed')
			return 'bg-primary text-white'
	}

	async function getData() {
		var filterCopy = { ...filter }
		filterCopy.reservation_date = formatDate(filterCopy.reservation_date, 'yyyy-MM-dd')
		const response = await GET('/reservations', filterCopy, { loader: true })
		if (httpOk(response)) setData(response.data)

		const responseHalls = await GET('/reservations-halls')
		if (httpOk(responseHalls)) {
			setHalls(responseHalls.data)
			if (responseHalls.data.length > 0) selectHall(responseHalls.data[0], responseHalls.data)
		}
	}

	useEffect(() => {
		getData()
	}, [filter]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="w-100 p-2">
				<div className="card" style={{ 'height': 'calc(100vh - 70px)' }}>
					<div className="card-body pb-0">
						<div className="d-flex flex-column justify-content-between h-100">
							{activeTab === 1 &&
								<div className="d-flex gap-2">
									<table className="table table-bordered table-hover cursor"
										style={{ 'width': '15%', 'alignSelf': 'flex-start' }}>
										<thead>
											<tr>
												<th style={{ 'width': '130px' }}>{t('hall')}</th>
											</tr>
										</thead>
										<tbody>
											{halls?.map((item, index) => (
												<tr key={index}
													className={item.active ? 'active-tab' : ''}>
													<td className="td-ellipsis" onClick={() => selectHall(item)}>{item.name}</td>
												</tr>
											))}
										</tbody>
									</table>
									<div style={{ 'height': 'calc(100vh - 160px)', 'overflow': 'auto' }}>
										<table className="table table-bordered table-hover"
											style={{ 'width': '85%', 'alignSelf': 'flex-start' }}>
											<thead>
												<tr>
													<th style={{ 'minWidth': '70px' }}>{t('table')}</th>
													{hours.map(hour => (
														<th key={hour} style={{ 'minWidth': '33px' }} className="text-center">{hour}</th>
													))}
												</tr>
											</thead>
											<tbody>
												{tables?.map((item, index) => (
													<tr key={index}>
														<td className="td-ellipsis">{item.name}</td>
														{hours.map(hour => (
															<td key={hour}
																style={{ 'width': '33px', 'minWidth': '33px', }}
																className={`text-center ${isReserved(item.id, hour) ? "bg-danger" : "bg-success"}`}>
															</td>
														))}
													</tr>
												))}
											</tbody>
										</table>
									</div>
								</div>
							}

							{activeTab === 2 &&
								<table className="table table-bordered">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '30%' }}>{t('hall')} / {t('table')}</th>
											<th style={{ 'minWidth': '110px' }} className="text-center">{t('time')}</th>
											<th style={{ 'minWidth': '115px' }} className="text-center">{t('status')}</th>
											<th style={{ 'width': '20%' }}>{t('name2')}</th>
											<th style={{ 'minWidth': '150px' }} className="text-nowrap">{t('phone')}</th>
											<th style={{ 'width': '30%' }}>{t('note')}</th>
											<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('paid')}</th>
											<th style={{ 'width': '10%' }} className="text-start text-nowrap">{t('created_by')}</th>
											<th style={{ 'minWidth': '115px' }} className="text-center text-nowrap">{t('created')}</th>
										</tr>
									</thead>
									<tbody>
										{data?.map((item, index) => (
											<tr key={index} onClick={() => toggleModalCancel(true, item)}>
												<td className="text-center">{index + 1}</td>
												<td className="td-ellipsis">{item.hall_name} / {item.table_name}</td>
												<td className="text-center">
													<b>{item.reservation_start_time}</b>
													{!!item?.reservation_end_time &&
														<>
															-
															<b>{item?.reservation_end_time}</b>
														</>
													}
												</td>
												<td className={`text-center ${returnClassReservation(item.status)}`}>{t(item.status)}</td>
												<td className="td-ellipsis">{item.client_name}</td>
												<td className="td-ellipsis">{regexPhoneNumber(item.client_phone)}</td>
												<td className="td-ellipsis">{item.note}</td>
												<td className="text-end">{formatMoney(item.amount)}</td>
												<td className="text-start">{item.created_by}</td>
												<td className="text-center text-nowrap">{formatDate(item.created_at, 'dd.MM.yy HH:mm')}</td>
											</tr>
										))
										}
									</tbody>
								</table>
							}

							<div className="d-flex justify-content-between"
								style={{ 'height': '70px', 'borderTop': '1px solid #eee' }}>
								<button className="delivery-btn" style={{ 'width': '80px' }}
									onClick={() => setActiveTab(activeTab === 1 ? 2 : 1)}>
									{activeTab === 1 &&
										<span>{t('tables')}</span>
									}
									{activeTab === 2 &&
										<span>{t('time')}</span>
									}
								</button>
								<div className="booking-date">
									<div className="booking-date-btn" onClick={() => changeDate(-1)}>
										<i className="uil-angle-left-b"></i>
									</div>
									<DatePicker
										selected={filter.reservation_date}
										onChange={(date) => setFilter({ ...filter, 'reservation_date': date })}
										withPortal
										dateFormat="dd.MM.yyyy"
										portalId="root-portal"
										className="booking-date-picker"
									/>
									<div className="booking-date-btn" onClick={() => changeDate(1)}>
										<i className="uil-angle-right-b"></i>
									</div>
								</div>
								<button className="delivery-btn" style={{ 'width': '80px' }}
									onClick={() => toggleModalCreate(true)}>
									{t('create')}
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* MODAL TABLE STATUS */}
			<Modal show={modalStatus} animation={false} centered
				onHide={() => toggleModalCancel()}>
				<Modal.Body className="p-0" style={{ 'height': '300px', 'overflow': 'auto' }}>
					<div className="d-flex flex-column justify-content-between h-100 p-2">
						<div>
							<div className="d-flex justify-content-between">
								<div>{t('hall')} / {t('table')}</div>
								<div>{selectedItem.hall_name} / {selectedItem.table_name}</div>
							</div>
							<div className="d-flex justify-content-between">
								<div>{t('date')}:</div>
								<div>{formatDate(selectedItem.reservation_date)}</div>
							</div>
							<div className="d-flex justify-content-between">
								<div>{t('time')}:</div>
								<div>
									<span>{selectedItem?.reservation_start_time?.substring(0, 5)}</span>
									{!!selectedItem?.reservation_end_time &&
										<>
											-
											<span>{selectedItem?.reservation_end_time?.substring(0, 5)}</span>
										</>
									}
								</div>
							</div>
							<div className="d-flex justify-content-between">
								<div>{t('client')}:</div>
								<div>{selectedItem.client_name}</div>
							</div>
							<div className="d-flex justify-content-between">
								<div>{t('phone')}:</div>
								<div>{selectedItem.client_phone}</div>
							</div>
							<div className="d-flex justify-content-between">
								<div>{t('paid')}:</div>
								<div>{formatMoney(selectedItem.amount)}</div>
							</div>
							<hr className="m-0" />
							<div className="d-flex justify-content-between">
								<div>{t('created')}:</div>
								<div>{formatDate(selectedItem.created_at, 'dd.mm.yy HH:mm')}</div>
							</div>
							<div className="d-flex justify-content-between">
								<div>{t('manager')}:</div>
								<div>{selectedItem.created_by}</div>
							</div>
						</div>

						<div className="d-flex gap-2">
							<button type="button" className="btn btn-danger w-100"
								onClick={() => update()}>
								{t('cancel_reservation')}
							</button>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL TABLE STATUS */}

			{/* MODAL CREATE */}
			<Modal show={modalCreate.bool} animation={false} centered
				size="xl" onHide={() => toggleModalCreate(false)}>
				<Modal.Body>
					<form className="d-flex gap-2" autoComplete="off"
						style={{ 'height': 'calc(100vh - 260px)', 'overflow': 'auto' }}>
						<div className="d-flex flex-column">
							<div className="form-group">
								<div className="input-group">
									<div className="input-group-prepend">
										<span className="input-group-text">998</span>
									</div>
									<input
										autoFocus
										type="text"
										name="phone"
										placeholder={t('phone')}
										className="form-control"
										value={modalCreate.data.phone ?? ""}
										onChange={(e) => handleChange(e)}
										onKeyUp={(event) => {
											if (event.key === 'Enter') {
												searchClient()
											}
										}}
									/>
								</div>
							</div>

							<div className="form-group">
								<input
									type="text"
									name="client_name"
									placeholder={t('name2')}
									className="form-control"
									value={modalCreate.data.client_name ?? ""}
									onChange={(e) => handleChange(e)}
								/>
							</div>

							<div className="form-group">
								<input
									type="number"
									name="amount"
									placeholder={t('prepayment')}
									className="form-control"
									value={modalCreate.data.amount ?? ""}
									onChange={(e) => handleChange(e)}
								/>
							</div>

							<div className="form-group">
								<textarea
									type="text"
									name="note"
									placeholder={t('note')}
									className="form-control" rows={2}
									value={modalCreate.data.note ?? ""}
									onChange={(e) => handleChange(e)}
								/>
							</div>

							<div className="form-group">
								<DatePicker
									minDate={new Date()}
									selected={modalCreate.data.reservation_date}
									onChange={(date) => setModalCreate({
										...modalCreate,
										data: {
											...modalCreate.data,
											reservation_date: date
										}
									})}
									inline
								/>
							</div>

							<div className="form-group">
								<Select
									isClearable
									options={timeList}
									value={timeList.find(option => option.id === modalCreate.data.reservation_start_time) || ''}
									onChange={(option) => setModalCreate({
										...modalCreate,
										data: {
											...modalCreate.data,
											reservation_start_time: option?.id
										}
									})}
									placeholder={t('time')}
									noOptionsMessage={() => ""}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
									menuPlacement="top"
								/>
							</div>

							<div className="form-group">
								<Select
									isClearable
									options={timeList}
									value={timeList.find(option => option.id === modalCreate.data.reservation_end_time) || ''}
									onChange={(option) => setModalCreate({
										...modalCreate,
										data: {
											...modalCreate.data,
											reservation_end_time: option?.id
										}
									})}
									placeholder={t('time')}
									noOptionsMessage={() => ""}
									getOptionLabel={(option) => option.name}
									getOptionValue={(option) => option.id}
									menuPlacement="top"
								/>
							</div>
						</div>

						<div className="waiter-body h-100 w-100">
							<div className="waiter-body-left"
								style={{
									minWidth: '200px',
									maxWidth: '200px',
									backgroundColor: 'transparent'
								}}>
								{modalCreate?.halls?.map((item, index) => (
									<div className={'item-box ' + (item.active ? 'active-tab' : '')} key={index}
										onClick={() => selectHallModal(item)}>
										<div className="item-box-inner-name">
											{item.name}
										</div>
									</div>
								))}
							</div>
							<div style={{ 'width': '80%' }}>
								<div className="d-flex flex-wrap">
									{modalCreate?.tables?.map((item, index) => (
										<div className={`table-box ${item.id === modalCreate.data.table_id ? 'table-box-active' : ''}`} key={index}
											onClick={() => setModalCreate({
												...modalCreate,
												data: {
													...modalCreate.data,
													'table_id': item.id,
													'table_name': item.name
												}
											})}>
											{item.name}
										</div>
									))}
								</div>
							</div>
						</div>
					</form>

					<div className="waiter-footer justify-content-end">
						<button className="btn btn-primary m-0"
							onClick={(e) => create(e)}>
							{t('save')}
						</button>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL CREATE */}
		</>
	)
}

export default Index